import { render, staticRenderFns } from "./CreateLeadDialog.vue?vue&type=template&id=2d8f7442"
import script from "./CreateLeadDialog.vue?vue&type=script&lang=ts"
export * from "./CreateLeadDialog.vue?vue&type=script&lang=ts"
import style0 from "./CreateLeadDialog.vue?vue&type=style&index=0&id=2d8f7442&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports